import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import './SalesOpportunities.scss';

// Training video thumbnail image
import thumbnail1 from '../../../images/features/soldiers.png';

class SalesOpportunities extends React.Component { // eslint-disable-line react/prefer-stateless-function
    static propTypes = {};

    static defaultProps = {};

    render() {
        return (
            <div className="sales-opportunities-page">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>NFFS ICON - Sales Opportunities</title>
                </Helmet>

                <Container className="content-container mt-5 mb-5">
                    <Row>
                        <Col>
                            <h1 className="page-title mb-4">Sales Opportunities</h1>
                            <div className="content-box p-4">
                                <h2>Daily sales opportunities matched to your plant capabilities</h2>
                                <p className="lead">
                                    This feature will provide you with daily sales opportunities that are perfectly matched to your plant&apos;s specific
                                    capabilities or existing tooling.
                                </p>
                                <hr />
                                <h3>Feature highlights:</h3>
                                <ul>
                                    <li>Automated matching algorithm finds relevant opportunities</li>
                                    <li>Daily updates with new potential sales leads</li>
                                    <li>Filter by location, material, dimensions, and more</li>
                                    <li>Easily connect with potential clients</li>
                                    <li>Export opportunities to CSV for team sharing</li>
                                </ul>
                                <div className="alert alert-info mt-4">
                                    <strong>Coming Soon:</strong> This feature is currently under development and will be available in a future update.
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Training Videos Section */}
                    <Row className="mt-5">
                        <Col xs={12}>
                            <h2 className="mb-4">Training Videos</h2>
                            <p className="mb-4">Watch these training videos to learn how to get the most out of the Sales Opportunities feature.</p>
                        </Col>
                    </Row>
                    <Row className="mb-5">
                        <Col xs={12} md={4} className="mb-4">
                            <div className="video-thumbnail-card">
                                <div className="video-thumbnail">
                                    <img src={thumbnail1} alt="How to Find Sales Opportunities" className="img-fluid" />
                                    <div className="play-button">
                                        <i className="fa fa-play-circle-o" />
                                    </div>
                                </div>
                                <div className="video-info p-3">
                                    <h5>How to Find Sales Opportunities</h5>
                                    <p className="text-muted">Learn how to search and filter opportunities based on your plant capabilities.</p>
                                    <p><small className="text-muted">Duration: 4:30</small></p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default SalesOpportunities; 


// WEBPACK FOOTER //
// ./src/pages/static/SalesOpportunities/SalesOpportunities.jsx